import { createToObject } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Metrics } from '../utils/metrics';
import { useIsPaidPortal } from '../v2/hooks/inventory/useProductInventory';
import { useIsInAppAuth } from '../v2/hooks/user/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotCreditsRedirect = () => {
  const isInApp = useIsInAppAuth();
  const {
    isPaidPortal,
    loading
  } = useIsPaidPortal();
  const redirectPath = isInApp && isPaidPortal ? '/add-ons' : '/';
  const getPortalType = () => {
    if (!isInApp) return 'public';
    if (isPaidPortal) return 'paid';
    return 'free';
  };
  const portalType = getPortalType();
  useEffect(() => {
    if (!loading) {
      Metrics.counter('hubspot-credits-page-redirect', {
        redirectTo: redirectPath,
        referrer: document.referrer || 'direct',
        portalType
      }).increment();
    }
  }, [loading, redirectPath, portalType]);
  if (isInApp && loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: createToObject(redirectPath)
  });
};